import { createSlice } from "@reduxjs/toolkit";

const initialState: IPowerLimitState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const powerLimitSlice = createSlice({
  name: "powerLimit",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replacePowerLimit: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addPowerLimit: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updatePowerLimit: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.Details = data;
    },
    deletePowerLimit: (state, action) => {
      const powerLimitToRemove: IPowerLimit = action.payload.data;
      const newPowerLimitData =
        state.data &&
        state.data.filter((powerLimit: IPowerLimit) => {
          return powerLimit.id !== powerLimitToRemove.id;
        });
      state.data = newPowerLimitData;
      state.totalCount = state.totalCount - 1;
    },
    setPowerLimitDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const powerLimitActions = powerLimitSlice.actions;
export default powerLimitSlice.reducer;
